export enum StatementStatusEnum
{
	NotCreated = "NotCreated",
	Created = "Created",
	Signed = "Signed",
	Sent = "Sent",
	Received = "Received"
}
